module.exports = __webpack_public_path__ + "img/bcd1b1571e0b8d970f45cdc2bb67efc.b71c3c00.jpg";